import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { take } from "rxjs/operators";
import { InvDailyBalance } from "../model/inv-daily-balance.model";
import { PagingDataResult } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "ngx-inv-daily-balance",
  templateUrl: "./inv-daily-balance.component.html",
  styleUrls: ["./inv-daily-balance.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyBalanceComponent extends BaseFormComponent<InvDailyBalance> {
  dataList: InvDailyBalance[] = [];
  BranchLookUp: Branch[] = [];
  goodsList: any[];

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, __id: FormContainerModel, _tabsservice: TabularService) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }

  async ngOnInit() {
    this.apiName = "InvDailyBalance";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyBalance");
    super.ngOnInit();
    await this.FillData();
  }

  async FillData() {
    const data = await (<Promise<Branch[]>>this.httpCommonService.getList("Branch").pipe(take(1)).toPromise());
    if (this.isMultiBranch) this.BranchLookUp = data.filter((x) => !x.AccessToAllBranches && x.IsActive);
    else this.BranchLookUp = data.filter((x) => x.Id == this.accountService.authService.currentBranchId);

    if (this.isMultiBranch) {
      this.httpCommonService
        .get("Item/ReadInvDailyGoodsLookUpPaging")
        .pipe(take(1))
        .subscribe((res: PagingDataResult<any>) => {
          this.goodsList = res.Data;
          this.selectorService.setDataList("GoodsId", this.goodsList);
        });
    }
  }

  setdefault(): void {
    if (!this.isMultiBranch) {
      this.model.BranchId = this.accountService.authService.currentBranch?.Id;
      this.loadInvDailyBalances();
    }
  }

  setColumnAttribute(): void {
    const goodsIdControl = this.columns.find((x) => x.name === "GoodsId");
    const goodsTitleControl = this.columns.find((x) => x.name === "GoodsTitle");
    if (goodsIdControl && !goodsIdControl["custom"]) {
      goodsIdControl.name = "GoodsTitle";
      goodsIdControl["custom"] = true;
    }
    if (goodsTitleControl && !goodsTitleControl["custom"]) {
      goodsTitleControl.name = "GoodsId";
      goodsTitleControl["custom"] = true;
      goodsTitleControl.listVisible = false;
    }
  }

  addControl(): void {
    this.setValue("BranchId", this.model.BranchId);
    if (!this.isMultiBranch) this.formGroup.controls["BranchId"].disable();
  }

  loadInvDailyBalances(): void {
    const branchId = this.formGroup.controls["BranchId"].value;
    if (branchId) {
      this.httpCommonService
        .get("InvDailyBalance/GetAllBalance?branchId=" + branchId)
        .pipe(take(1))
        .subscribe((res: InvDailyBalance[]) => {
          this.dataList = res;
          if (this.isMultiBranch) {
            const list = this.goodsList.filter((x) => x.BranchId == branchId || x.BranchId == 0);
            this.selectorService.setDataList("GoodsId", list);
          }
          this.cd.markForCheck();
        });
    }
  }

  public async save(): Promise<void> {
    try {
      this.preSave();
      if (!this.isSaving) {
        if (this.isValid()) {
          this.beforupdate();
          this.sts.showToast("info", "", this.translate("ClientApp.FrontOffice.Inv.DailyBalance.SavingChanges"));
          this.isSaving = true;
          this.isSaved = false;
          this.dataList.forEach((x) => {
            x.BranchId = this.formGroup.controls["BranchId"].value;
          });
          this.httpCommonService
            .create("InvDailyBalance/SaveBalance", this.dataList)
            .pipe(take(1))
            .toPromise()
            .then(
              (row) => this.saveSuccessHelper(row),
              (error) => this.saveFailedHelper(error)
            );
        } else {
          this.selectorService.submitted$.next(this.submitted);
        }
      } else {
        this.selectorService.submitted$.next(this.submitted);
      }
    } catch (e) {
      this.saveFailedHelper(e);
    }
  }

  isValid(): boolean {
    if (!this.formGroup.controls["BranchId"].value) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyBalance.EnteringBranchRequired"),
        this.translate("ClientApp.FrontOffice.Inv.DailyBalance.Attention")
      );
      return false;
    }
    if (!this.dataList.length) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyBalance.EnterRequiredMinimizeItem"),
        this.translate("ClientApp.FrontOffice.Inv.DailyBalance.Attention")
      );
      return false;
    }

    return true;
  }

  ngOnDestroy(): void {
    this.selectorService.dataList["GoodsId"] = null;
    delete this.selectorService.dataList["GoodsId"];
    super.ngOnDestroy();
  }
}
